<template>
  <b-modal
    ref="modal"
    id="send-message-modal"
    :title="counselorMode ? 'Request a Counselor' : 'Request a School'"
  >
    <form-component>
      <form novalidate="novalidate">
        <input-text
          v-if="!counselorMode"
          id="school_name"
          v-model="school_name"
          v-validate="'required'"
          name="school_name"
          data-vv-name="school_name"
          data-vv-as="school name"
          label="Your School"
          type="text"
          required
          :error="errors.first('school_name')"
        />

        <input-text
          id="name"
          v-model="name"
          v-validate="'required'"
          name="name"
          data-vv-name="name"
          data-vv-as="name"
          label="Your Name"
          type="text"
          required
          :error="errors.first('name')"
        />

        <input-text
          id="email"
          v-model="email"
          v-validate="'required'"
          name="email"
          data-vv-name="email"
          data-vv-as="email"
          label="Your Email"
          type="text"
          required
          :error="errors.first('email')"
        />

        <input-text-area
          id="message"
          v-model="message"
          v-validate="'required'"
          name="message"
          data-vv-name="message"
          data-vv-as="message"
          label="Your Message"
          type="text"
          required
          :error="errors.first('message')"
        />
      </form>
    </form-component>

    <template
      slot="modal-footer"
      slot-scope="{ ok, cancel }"
    >
      <button
        class="btn"
        type="button"
        @click="hide()"
      >
        Cancel
      </button>
      <button
        class="btn btn--primary"
        type="button"
        :disabled="saving"
        @click="save()"
      >
        <font-awesome-icon
          v-if="saving"
          :spin="true"
          :icon="['fas', 'spinner']"
          class="icon alt"
        />
        <span v-else>Send</span>
      </button>
    </template>
  </b-modal>
</template>

<script>
import FormComponent from '@/components/FormComponent.vue';
import InputText from '@/components/inputs/InputText.vue';
import InputTextArea from '@/components/inputs/InputTextArea.vue';
import UserClient from '@/api/UserClient';

export default {
  name: 'SendMessageModal',
  components: {
    FormComponent,
    InputText,
    InputTextArea,
  },
  data() {
    return {
      userClient: new UserClient(this.$http),
      saving: false,
      counselorMode: false,
      school_name: '',
      name: '',
      email: '',
      message: '',
    };
  },
  methods: {
    show() {
      this.school_name = '';
      this.name = '';
      this.email = '';
      this.message = '';
      this.counselorMode = false;

      this.$refs.modal.show();
    },
    showCounselorMode() {
      this.school_name = '';
      this.name = '';
      this.email = '';
      this.message = '';
      this.counselorMode = true;

      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },

    save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.errors.clear();
          this.saving = true;

          (this.counselorMode ? this.userClient.submitContact(this.email, this.name, this.message) : this.userClient.requestSchool(this.school_name, this.name, this.email, this.message)).then(res => {
            this.saving = false;
            this.hide();
            this.$store.commit('setGlobalAlert', {
              msg: 'Request Sent!',
            });
          }).catch(ex => {
            this.$store.commit('setGlobalAlert', {
              msg: 'Failed to send request. Please try again!', error: true,
            });
            this.saving = false;
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
